module.exports = __webpack_public_path__ + "static/media/img-topics-sample05.0fb9d4ac.jpg";